import React from 'react';
import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    Button, 
    Typography,
    Divider,
    Box,
} from '@mui/material';
import celebrationImg from '../../../images/confetti.png';

function DiscountAccepted({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ color: "black", pt: 4, pl: 4, fontSize: '24px', fontWeight: '600' }}>You’re all set!</DialogTitle>
      <DialogContent sx={{ pl: 4, pb: 4, mr: 3, ml: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, mb: 4 }}>
        <img
            src={celebrationImg}
            alt="Celebration"
            style={{ width: 120, height: 'auto' }} // adjust size as needed
          />
        </Box>
        <Typography sx={{ color: 'gray', mt: 1, pb: 2, fontSize: '18px', textAlign: 'center' }}>Your 30% discount has been applied!</Typography>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ pb: 4, pr: 4, pt: 3 }}>
        <Button onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>  
  );
}

export default DiscountAccepted;
